import * as React from "react";
import {Theme, useMediaQuery, useTheme} from "@material-ui/core";

export const logger = console;

export const BreakpointProvider: React.FC<{ children: (isDesktop: boolean) => React.ReactNode }> = ({children}) => {
    const theme: Theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

    return <>{children(isDesktop)}</>;
};



// WEBPACK FOOTER //
// ./src/utils.tsx